import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import PostTable from '@cms/components/tables/post-table/post-table.vue';

@Component({
  name: 'bpc-post-pages',
  components: {
    'bpc-post-table': PostTable,
  },
})
export default class PostPages extends Vue {
  public filterConfigName = 'pages-filters';

  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
